export default "//file.bilionpass.com/japandx-web/0.0.1/static/upcoming.b7b3e444-752119.svg";